module.exports = __webpack_public_path__ + "img/info_hint.81f3dcc4.svg";